var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: {
        id: "description-view-modal",
        title: _vm.title || "Просмотр описания",
        active: _vm.active,
        "hide-footer": !_vm.canEdit,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                staticClass: "description-view__close",
                attrs: { label: "Закрыть", size: "large" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: {
                  label: "Редактировать",
                  color: "primary",
                  size: "large",
                },
                on: { click: _vm.edit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "description-view" }, [
        _vm.description
          ? _c("div", {
              staticClass: "text",
              domProps: { innerHTML: _vm._s(_vm.description) },
            })
          : _vm._e(),
        _vm.link
          ? _c("div", { staticClass: "link" }, [
              _c("div", { staticClass: "link__wrapper" }, [
                _c("a", { attrs: { href: _vm.link, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.link)),
                ]),
                _c(
                  "button",
                  { staticClass: "link__copy", on: { click: _vm.copy } },
                  [_c("svg-icon", { attrs: { name: "copy", size: 16 } })],
                  1
                ),
              ]),
              _vm.copied
                ? _c(
                    "div",
                    { staticClass: "link__copied" },
                    [
                      _c("svg-icon", {
                        attrs: { name: "check", color: "success" },
                      }),
                      _vm._v(" Ссылка скопирована "),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _c("div", { staticClass: "files" }, [
          _vm.docs.length
            ? _c(
                "div",
                { staticClass: "docs" },
                [_c("files", { attrs: { files: _vm.docs, actions: true } })],
                1
              )
            : _vm._e(),
          _vm.images.length
            ? _c(
                "div",
                { staticClass: "images" },
                [
                  _c("files", {
                    attrs: {
                      files: _vm.images,
                      actions: "preview",
                      "show-video": true,
                      "full-width": true,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }